import React from "react";
import strings from "../../helpers/Localization";
import ButtonSKA from "../Buttons/ButtonSKA";
import TagChip from "./TagChip";
import Modal from "../Modal/Modal";

const EditTags = ({ allTags, elementTags, onChangeTags, onOpenModal, onCloseModal }) => {
    const [tagsModalsOpen, setTagsModalsOpen] = React.useState(false);
    const [tagsToAdd, setTagsToAdd] = React.useState([]);
    const [tagsToCreate, setTagsToCreate] = React.useState([]);
    const [tagsToRemove, setTagsToRemove] = React.useState([]);
    const [newTag, setNewTag] = React.useState("");

    const openModal = () => {
        if (onOpenModal) {onOpenModal();}
        setTagsModalsOpen(true);
    };
    const closeModal = () => {
        if (onCloseModal) {onCloseModal();}
        setTagsModalsOpen(false);
    };

    return <>
        <div style={{ flexGrow: "1", flex: "1", flexShrink: "0", display: "flex",
            alignItems: "center", justifyContent: "flex-start", gap: "10px" }}
        >
            <span>{strings.assignTags}</span>
            {
                elementTags.map((etag) => {
                    return <TagChip
                        key={etag.value}
                        tagName={etag.value}
                        onDelete={() => {
                            onChangeTags(elementTags.filter(t => t.value !== etag.value));
                        }}
                    />;
                })
            }
            <span style={{ display: "flex", flexGrow: "1" }}/>
            <ButtonSKA
                type="secondary-icon"
                onClick={(e) => onChangeTags([])}
                nameIcon="reset"
                text={strings.clear}
            />
            <ButtonSKA
                type="primary-icon"
                onClick={(e) => openModal()}
                nameIcon="add"
                text={strings.addTag}
            />
        </div>
        <Modal
            open={tagsModalsOpen}
            onClose={() => closeModal()}
            title={strings.addTag}
            icon={"add"}
            onValidate={() => {
                closeModal();
                const createList = tagsToCreate;
                const addList = tagsToAdd;
                if (newTag && newTag !== "") {
                    const existingTag = allTags.find(t => t.value === newTag);
                    if (existingTag) {
                        if (!elementTags.some(t => t.value === existingTag.value) && !tagsToAdd.some(t => t.value === existingTag.value) && !tagsToRemove.some(t => t.value === existingTag.value)) {
                            addList.push(existingTag);
                        }
                    }
                    else {
                        createList.push({
                            id: 0,
                            value: newTag
                        });
                    }
                }
                onChangeTags([...elementTags.filter(t => !tagsToRemove.some(etag => t.value === etag.value)), ...addList, ...createList]);
                setTagsToAdd([]);
                setTagsToRemove([]);
                setTagsToCreate([]);
                setNewTag("");
            }}
            fields={[
                {
                    type: "textfield",
                    title: strings.newTag,
                    placeholder: strings.myNewTag,
                    value: newTag,
                    onChange: (e) => { setNewTag(e.target.value); }
                },
                {
                    type: "custom",
                    title: strings.existingtags,
                    child: <div style={{ display: "flex", flexDirection: "row", flexGrow: "1", flexWrap: "wrap", gap: "10px" }}>
                        {
                            (allTags ? allTags : []).map((tag) => {
                                const isSelected = (elementTags && elementTags.some(t => t.value === tag.value)
                            || tagsToAdd.some(t => t.value === tag.value)) && !tagsToRemove.some(t => t.value === tag.value);
                                return <TagChip
                                    key={tag.value}
                                    selected={isSelected}
                                    tagName={tag.value}
                                    onSelect={() => {
                                        if (isSelected) {
                                            if (tagsToAdd.some(t => t.value === tag.value)) {
                                                setTagsToAdd(tagsToAdd.filter(t => t.value !== tag.value));
                                            }
                                            setTagsToRemove([...tagsToRemove, tag]);
                                        }
                                        else {
                                            if (tagsToRemove.some(t => t.value === tag.value)) {
                                                setTagsToRemove(tagsToRemove.filter(t => t.value !== tag.value));
                                            }
                                            setTagsToAdd([...tagsToAdd, tag]);
                                        }
                                    }}
                                />;
                            })
                        }
                    </div>
                }
            ]}
        >
        </Modal>
    </>;
};

export default EditTags;
